import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EssentialService {

  constructor(private httpClient: HttpClient) { }

  public getPosts(request: any) {
    // return this.httpClient.get(`/BolgArchive/GetPosts/1/1/1000/${ids}`);
    return this.httpClient.post<any>("/BolgArchive/GetPosts", request);

  
  }
  public getData(apiLink: string) {
    return this.httpClient.get(apiLink);
  }
  public getCategoryMenus(id: number) {
    return this.httpClient.get(`/Menus/GetMenusByCategoryId/${id}/2`);
  }
  public getMediaData(path: string) {
    return this.httpClient.post('/Media/GetFolderContent', { folderPath: path ? path : null });
  }
  public postData(apiLink: string, requestBody: any) {
    return this.httpClient.post(apiLink, requestBody);
  }
  public search(query: any) {
    return this.httpClient.post('/Search/full-search', query);
  }
}
